export default __webpack_public_path__ + "static/media/sort-alphabetical.30beaf6c.svg";